import { useState } from 'react'

const POIMarkerImage = ({ image }) => {
    const [isVisible, setIsVisible] = useState(true)

    const onImageError = () => {
        setIsVisible(false)
    }

    return image && isVisible && <img src={image} onError={onImageError} />
}

export default POIMarkerImage
